module.exports = __webpack_public_path__ + "img/nico-novacek.cea1aba5.jpg";